import "core-js/stable";
import React, {useContext} from 'react';
import {Helmet} from "react-helmet";
import MobXContext from "../../app/mobx/MobXContext";
import {observer} from "mobx-react";

const propTypes = {};
const defaultProps = {};

const Headers = () => {
	const {appStore} = useContext(MobXContext);

	return (
		<Helmet>
			<title>{appStore.pageTitle}</title>
		</Helmet>
	);
};

Headers.propTypes = propTypes;
Headers.defaultProps = defaultProps;

export default observer(Headers);
